// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"32":"dcd388c2","278":"c88be3aa","281":"0a24afe4","329":"ff457d9a","349":"d19c2a5e","406":"921c6197","754":"ee7990b9"}[chunkId] + ".chunk.js";
};